<template>
    <div class="text-center">
        <div class="loader" :style="`margin-top: ${height/2 - 20}px`"></div>
        <span>{{message}}</span>
    </div>
</template>

<script>
    export default {
        props: {
            height: {
                default: 60
            }
        },
        data() {
            return {
                message: ''
            }
        },
        created() {
            setTimeout(() => {
                this.message = 'loading, please wait'
            }, 10000);
            setTimeout(() => {
                this.message = 'we are working on it'
            }, 20000);
            setTimeout(() => {
                this.message = 'this is a heavy one'
            }, 40000);
            setTimeout(() => {
                this.message = "don't give up yet"
            }, 60000);
            setTimeout(() => {
                this.message = 'just a litle bit more'
            }, 90000);
        },
    }
</script>

<style scoped>
    .loader,
    .loader:after {
        border-radius: 50%;
        width: 5em;
        height: 5em;
    }
    .loader {
        margin: auto;
        font-size: 10px;
        position: relative;
        text-indent: -9999em;
        border-top: 0.5em solid rgba(0,13,255, 0.2);;
        border-right: 0.5em solid rgba(0,13,255, 0.2);;
        border-bottom: 0.5em solid rgba(0,13,255, 0.2);
        border-left: 0.5em solid #dce1e2;
        -webkit-transform: translateZ(0);
        -ms-transform: translateZ(0);
        transform: translateZ(0);
        -webkit-animation: load8 1.1s infinite linear;
        animation: load8 1.1s infinite linear;
    }
    @-webkit-keyframes load8 {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    @keyframes load8 {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
</style>

